import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useFacultyCreate } from '@/module/Faculty/model/FacultyQuery';
import { FacultySchema, defaultFacultyValues, facultySchema } from '@/module/Faculty/model/FacultySchema';

import { useAppNotification } from '@feature/utils';

import { FacultyForm } from './FacultyForm';

export function FacultyCreate() {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useFacultyCreate();

  const notification = useAppNotification();
  const navigate = useNavigate();

  const onSubmit = (values: FacultySchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newFaculty => {
        notification.success();
        navigate({
          to: '/administration/faculty/$facultyId',
          params: { facultyId: String(newFaculty.id) },
        });
      },
    });
  };

  return (
    <FacultyForm
      title={t('faculties.form.title.create')}
      schema={facultySchema}
      defaultValues={defaultFacultyValues}
      values={undefined}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
